import type { HaNFacilityCategory } from "@lib/logic";

import { FacilityCategoryCard } from "./FacilityCategoryCard";

type FacilityCategoryGridProps = {
  categories: HaNFacilityCategory[];
  onOpen: (categoryId: string) => void;
};

export const FacilityCategoryGrid = ({ categories, onOpen }: FacilityCategoryGridProps) => {
  return (
    <ul className="grid grid-cols-2 gap-4 px-5 py-4">
      {categories.map(category => {
        return (
          <li key={category.id}>
            <FacilityCategoryCard
              category={category}
              onOpen={() => onOpen(category.id)}
            />
          </li>
        );
      })}
    </ul>
  );
};
